'use client';

import * as ENGINE from '@gnsx/genesys.js';


import { captureAppliedBuildStampFromDisk } from './buildStampState';
import { cancelPendingDistRefresh, markDistRefreshAfterBuildCompleted, markRefreshAfterBuildStarted } from './coordination';
import { reloadCurrentWorld } from './reloadWorld';

import { editorAssets, editorStore } from '@/editor/store/editorStore';

/**
 * Refresh editor state after a successful build or when `.editor/build-stamp.json` changes (file watcher).
 * Invalidates caches, refreshes class metadata and the asset tree, then optionally reloads the world.
 */
export async function refreshAfterBuild(options: { reloadWorld?: boolean } = {}): Promise<void> {
  const { reloadWorld = true } = options;
  cancelPendingDistRefresh();
  markRefreshAfterBuildStarted();
  try {
    ENGINE.resourceManager.invalidateResourceCache();
    await editorStore.assets.refreshClassInfos();
    await editorAssets.assetTree.refreshProjectDirectories();
    if (reloadWorld) {
      await reloadCurrentWorld();
    }
  } finally {
    await captureAppliedBuildStampFromDisk();
    markDistRefreshAfterBuildCompleted();
  }
}
